module.exports = __webpack_public_path__ + "static/media/M51A.da66b40f.PNG";